import getFetchWrapper from "./getFetchWrapper.js";
const useFetch = (config) => {
  return getFetchWrapper(config);
};
export { useFetch as default };
//# sourceMappingURL=useFetch.js.map
